import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const NAMES = ['Lucía P.', 'Martina G.', 'Sofía V.', 'Camila R.', 'Valentina M.', 'Julieta S.', 'Agustina L.', 'Florencia C.', 'Micaela B.', 'Rocío D.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const showPopup = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const time = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
      setPurchase({
        name,
        city,
        time
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Recurring every 30 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-229">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} className="fixed bottom-24 left-4 md:bottom-6 md:left-6 z-50 max-w-sm bg-mystic-800 border border-mystic-700 rounded-xl p-4 shadow-2xl flex items-start gap-4" data-id="element-230">
          <div className="w-10 h-10 rounded-full bg-gold-500/20 flex items-center justify-center shrink-0" data-id="element-231">
            <span className="text-xl" data-id="element-232">🎉</span>
          </div>
          <div className="flex-grow pr-4" data-id="element-233">
            <p className="text-sm text-slate-200 font-medium leading-tight mb-1" data-id="element-234">
              <span className="font-bold text-white" data-id="element-235">{purchase.name}</span> de{' '}
              {purchase.city} acaba de comprar EL CÓDIGO DEL MAGNETISMO
            </p>
            <p className="text-xs text-slate-400" data-id="element-236">
              hace {purchase.time} {purchase.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-500 hover:text-slate-300 transition-colors" data-id="element-237">
            <X className="w-4 h-4" data-id="element-238" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}